import { render } from "./ButtonCompetidores.vue?vue&type=template&id=08a5e696"
import script from "./ButtonCompetidores.vue?vue&type=script&lang=js"
export * from "./ButtonCompetidores.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__